import { Category } from '@/domain/impact-co2/entities/question.entity';
export function buildUrl(category: Category) {
  switch (category) {
    case 'ACCOMMODATION':
      return '/questions/accommodation';
    case 'ACCOMMODATION_PUBLIC':
      return '/questions/public-accommodation';
    case 'BUILDING':
      return '/questions/building';
    case 'CARGO':
      return '/questions/cargo';
    case 'CATERING_MEAL':
      return '/questions/catering-meal';
    case 'CATERING_BEVERAGE':
      return '/questions/catering-beverage';
    case 'DIGITAL':
      return '/questions/digital';
    case 'ENERGY':
      return '/questions/energy';
    case 'EQUIPMENT':
      return '/questions/equipment';
    case 'GENERATOR':
      return '/questions/generator';
    case 'MOBILITY':
      return '/questions/mobility';
    case 'MOBILITY_PUBLIC':
      return '/questions/public-mobility';
    case 'NON_RECYCLABLE_WASTE':
      return '/questions/waste-non-recyclable';
    case 'RECYCLABLE_WASTE':
      return '/questions/waste-recyclable';
    case 'WATER':
      return '/questions/water';
    case 'SCENOGRAPHY_NO_RECYCLABLE':
      return '/questions/scenographie-no-recyclable';
    case 'SCENOGRAPHY_RECYCLABLE':
      return '/questions/scenographie-recyclable';
    case 'OFFICE_SUPPLIES_NEW':
      return '/questions/office-supplies-new';
    case 'OFFICE_SUPPLIES_REFURBISH':
      return '/questions/office-supplies-refurbish';
    case 'BUILDING_HEATING':
      return '/questions/building-heating';
    case 'TEAM_MOBILITY':
      return '/questions/team-mobility';
    default:
      throw 'unknown category';
  }
}
